module.exports = __webpack_public_path__ + "img/xmasParty16.6d648a8a.jpg";